// The SignalR API allow us to define exponential increasing delay time for reconnection
// The delay time will be reset back to initial value once it has successfully reconnected.
export const defaultSignalRReconnectionDelay = [
    0,
    2000,
    2000,
    2000,
    5000,
    10000,
    30000,
]

const timeoutHelper = (timeout: number) => {
    return new Promise<void>((resolve, _) => {
        setTimeout(() => {
            resolve()
        }, timeout)
    })
}

export default timeoutHelper
